import Link from "next/link";

interface AuthCardShellProps {
  title: string;
  description: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function AuthCardShell({ title, description, children, footer }: AuthCardShellProps) {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-background overflow-hidden">
      <div className="w-full max-w-[400px] animate-in fade-in zoom-in-95 duration-500 p-4">
        <div className="mb-4 flex flex-col items-center justify-center gap-2">
          <a href="/" className="flex items-center gap-2">
            <img src="/logo.svg" alt="RankGrip" className="size-8" />
            <span className="text-xl font-semibold">RankGrip</span>
          </a>
        </div>

        <div className="bg-stone-50 dark:bg-stone-900/50 p-1 rounded-[14px] border border-stone-200 dark:border-stone-800">
          <div className="bg-white dark:bg-card rounded-xl border-0 shadow-none p-6">
            <div className="flex flex-col space-y-2 text-center mb-4">
              <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
              <p className="text-sm text-muted-foreground">{description}</p>
            </div>
            {children}
          </div>
        </div>

        {footer}

        <p className="px-8 mt-2 text-center text-sm text-muted-foreground">
          By continuing, you agree to our{" "}
          <Link
            href="/legal/terms-of-service"
            className="underline underline-offset-4 hover:text-primary"
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            href="/legal/privacy-policy"
            className="underline underline-offset-4 hover:text-primary"
          >
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
